// extracted by css-extract-rspack-plugin
export default {"header":"qBCjHHXsw8jLBXqI","title":"KeMvCbwWTgSlwWEy","label":"BDT3X6Q7AZcBtJN4"};